export const COPY = {
  trial_not_started: {
    topText: 'Upgrade to Premium',
    title: 'Start your free trial',
    description: `The feature you're trying to access is a part of our premium plan. Upgrade today and take your experience to the next level!`,
  },
  trial_expired: {
    topText: 'Trial expired',
    title: 'Upgrade now to continue',
    description:
      'Your trial has expired & the feature you are trying to access is a part of Premium plan.',
  },
  limit_exhausted: {
    topText: 'Trial limits exceeded',
    title: 'Upgrade now to continue',
    description:
      'The limits on your trial has been exhausted for this feature.',
  },
}

export const PREMIUM_FEATURES = [
  'Explore Content Ideas',
  'Content Studio',
  'Explore Keywords',
  'AI writing assistant',
  'Website content Auditing',
  'SEO content validation',
  'Content Gap Report',
  'Analytics & ROI',
]
